/**
 * Shared admin helpers — used by every /admin/* page.
 *
 * The admin token is held ONLY in sessionStorage (per browser tab) and is
 * sent as the X-Admin-Token header. It is never embedded in source code,
 * never rendered, and never persisted beyond the tab session.
 */

const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API_BASE = `${API}/api`;

const TOKEN_KEY = "liap-admin-token";

export const getToken = () => { try { return window.sessionStorage.getItem(TOKEN_KEY); } catch (_e) { return null; } };
export const saveToken = (t) => { try { window.sessionStorage.setItem(TOKEN_KEY, t); } catch (_e) { /* noop */ } };
export const dropToken = () => { try { window.sessionStorage.removeItem(TOKEN_KEY); } catch (_e) { /* noop */ } };

export async function adminFetch(path, options = {}) {
    const token = getToken();
    return fetch(`${API_BASE}${path}`, {
        ...options,
        headers: { ...(token ? { "X-Admin-Token": token } : {}), ...(options.headers || {}) },
    });
}

export async function adminUpload(kind, file) {
    const fd = new FormData();
    fd.append("file", file);
    return fetch(`${API_BASE}/admin/upload?kind=${encodeURIComponent(kind)}`, {
        method: "POST",
        headers: { "X-Admin-Token": getToken() || "" },
        body: fd,
    });
}

/** Fetch a private file as an object URL (img tags cannot send headers). */
export async function fetchAuthedBlobUrl(path) {
    try {
        const resp = await adminFetch(`/files/${path}`);
        if (!resp.ok) return null;
        return URL.createObjectURL(await resp.blob());
    } catch (_e) { return null; }
}

/** Token rejected mid-session → drop it and return to the gate. */
export function forceReauth() {
    dropToken();
    window.location.reload();
}
